
import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, CircleMarker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './App.css';
import Legend from './Legend';

// Leafletのデフォルトアイコンが正しく表示されない問題を修正
import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const API_TOKEN = '903aa9e32e8a3ffe8b7bc0a2aa51ab185c1fb6e5';

// PM2.5の値に基づいて色を決定する
const getColor = (aqi) => {
  if (aqi <= 50) return '#009966';
  if (aqi <= 100) return '#ffde33';
  if (aqi <= 150) return '#ff9933';
  if (aqi <= 200) return '#cc0033';
  if (aqi <= 300) return '#660099';
  return '#7e0023';
};

function App() {
  const [stations, setStations] = useState([]);
  const [date, setDate] = useState(new Date());
  const position = [35.6895, 139.6917]; // 初期位置を東京に設定

  useEffect(() => {
    console.log("Date changed:", date);
    // 表示領域の緯度経度を元にAPIを叩くのが望ましいが、今回は固定値で取得
    const bounds = '30,120,45,150'; // 日本周辺のおおよその範囲
    fetch(`https://api.waqi.info/map/bounds/?latlng=${bounds}&token=${API_TOKEN}`)
      .then(response => response.json())
      .then(data => {
        if (data.status === 'ok') {
          const stationsWithDust = data.data.map(station => ({
            ...station,
            hasDust: Math.random() < 0.1 // 10%の確率で黄砂情報を付加
          }));
          setStations(stationsWithDust);
        }
      })
      .catch(error => console.error('Error fetching data: ', error));
  }, [date]);

  return (
    <div>
      <div className="date-picker-container">
        <input 
          type="date" 
          value={date.toISOString().split('T')[0]} 
          onChange={(e) => setDate(new Date(e.target.value))} 
        />
      </div>
    <MapContainer center={position} zoom={5} style={{ height: '100vh', width: '100%' }}>
      <Legend />
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {stations.map(station => {
        const aqi = parseInt(station.aqi, 10);
        if (isNaN(aqi)) return null; // aqiが数値でない場合は表示しない

        return (
          <React.Fragment key={station.uid}>
          <CircleMarker
            center={[station.lat, station.lon]}
            pathOptions={{ 
              color: getColor(aqi),
              fillColor: getColor(aqi),
              fillOpacity: 0.7
            }}
            radius={Math.sqrt(aqi) * 0.5} // AQIの値に応じて円の大きさを変える
          >
            <Popup>
              <div>
                <h4>{station.station.name}</h4>
                <p>AQI: {station.aqi}</p>
                <p>Last updated: {station.station.time}</p>
              </div>
            </Popup>
          </CircleMarker>
          {station.hasDust && (
              <Marker position={[station.lat, station.lon]} icon={L.divIcon({ className: 'dust-icon', html: '黄' })} />
          )}
          </React.Fragment>
        );
      })}
    </MapContainer>
    </div>
  );
}

export default App;
